import { Academics } from "./Academics";

export default Academics;
